import formatOrder from '../helpers/format-order'
import composeStore from '../helpers/generate-pagination-data-store'
import resetStore from '../helpers/reset-store'

function composeParams(state, data) {

  const params = {}
  const limit = typeof data.limit === 'number' ? data.limit : 16
  const page = data.page || 1
  const sortDir = data.sortDir || -1
  const sortBy = data.sortBy || 'createdDate'

  params.$limit = limit
  params.$skip = (page - 1) * limit
  params.orderToApprove = data.orderToApprove
  params.orderStatus = data.orderStatus
  params.employees = data.employees
  params.departments = data.departments
  params[`$sort[${sortBy}]`] = sortBy ? sortDir : null
  params.includeExtraData = true

  if (data.orderedBy) {
    params['$sqs[$query]'] = data.orderedBy
    // params['$sqs[$query]'] = `*${data.orderedBy}*`
    params['$sqs[$fields]'] = [
      'custbody_bbs_opportunity_contact.value.name',
      'otherRefNum.keyword',
      'tranId.keyword'
    ]
  }

  if (data.depots) {
    params[
      'shipGroupList.shipGroup.destinationAddressRef.$attributes.internalId[$in]'
    ] = data.depots
  }

  if (data.ignore) {
    params['internalId[$nin]'] = data.ignore
  }

  if (data.originParams) {
    for (const key in data.originParams) {
      params[key] = data.originParams[key]
    }
  }

  params['createdDate[$gte]'] = data.startDate
  params['createdDate[$lte]'] = data.endDate

  return params
}

const initialStore = composeStore(
  'orders',
  [
    'pendingApproval',
    'history',
    'toApprove',
    'approved',
    'rejected',
    'homeHistory',
    'homePending',
    'countPending',
    'report'
  ],
  '/api/order',
  composeParams,
  formatOrder
)

export const state = () => ({
  ...initialStore.state,
  status: {
    'Pending Approval': {
      label: 'Pending approval',
      value: 'Pending approval',
      color: '#DEDEDE'
    },
    'Pending Supervisor Approval': {
      label: 'Pending Approval',
      value: 'Pending supervisor approval',
      color: '#DEDEDE'
    },
    'Order rejected': {
      label: 'Order rejected',
      value: 'Order rejected',
      color: '#F798A3'
    },
    'In Process': {
      label: 'In Process',
      value: 'n Process',
      color: '#F5B7B1'
    },
    'Part Despatched': {
      label: 'Part Despatched',
      value: 'Part Despatched',
      color: '#FAD7A0'
    },
    'Fully Despatched': {
      label: 'Fully Despatched',
      value: 'Fully Despatched',
      color: '#67E9BD'
    },
    Cancelled: {
      label: 'Cancelled',
      value: 'Cancelled',
      color: '#F798A3'
    },
    Closed: {
      label: 'Closed',
      value: 'Closed',
      color: '#F798A3'
    }
  }
})

export const getters = {
  ...initialStore.getter
}

export const mutations = {
  ...initialStore.mutation,
  reset: resetStore(state)
}

export const actions = {
  ...initialStore.action,
  async countPending({ dispatch }, params = {}) {
    dispatch('fetchOrders', {
      storeKey: 'countPending',
      limit: 0,
      orderToApprove: true,
      orderStatus: 'pending',
      ...params
    })
  },
}

export default {
  namespaced: true, // optional, if you want namespacing
  state,
  mutations,
  actions,
  getters,
};
